import {
	checkbox, CheckboxField,
	ComboBox,
	combobox,
	comp,
	datefield,
	fieldset, NumberField,
	numberfield,
	textarea,
	textfield
} from "@intermesh/goui";
import {FormWindow as GouiFormWindow, jmapds, modules, router} from "@intermesh/groupoffice-core";

import {t} from "./Translate";
export class FormWindow extends GouiFormWindow {
	private reminderIntervalNumber: NumberField;

	constructor() {
		super("Form");

		this.title = t("Form");
		this.stateId = "Form-dialog";
		this.maximizable = true;

		this.form.on("save", ({data, isNew}) => {
			//show detail when creating new Form
			if(isNew) {
				router.goto("forms/" + data.id);
			}
		})

		this.generalTab.items.add(
			fieldset({},

				textfield({
					flex: 2,
					name: "title",
					label: t("Title"),
					required: true
				}),

				combobox({
					width: 200,
					dataSource: jmapds("FormBook"),
					label: t("Book"),
					name: "bookId",
					filterName: "text",
					required: true,
					listeners: {
						render:async ({target}) => {
							//auto select first entry if no value set
							if(!target.value) {
								const records = await target.list.store.load()
								if(records.length) {
									target.value = records[0].id;
									target.trackReset();
								}
							}
						}
					}
				}),

				textarea({
					name: "description",
					label: t("Description"),
					autoHeight: true
				}),

				textarea({
					name: "thankYouText",
					label: t("Thank you page text"),
					autoHeight: true
				}),

				textarea({
					name: "closedText",
					label: t("Form closed text"),
					autoHeight: true,
					value: t("Sorry, the form is closed.")
				}),

				),

			fieldset({},
				datefield({
					label: t("Open"),
					name: "dateOpen"
				}),

				datefield({
					label: t("Closed"),
					name: "dateClosed"
				}),

			),


			fieldset({legend: t("Reminder")},
				checkbox({
					type: "switch",
					name: "reminderInterval",
					label: t("Send reminder"),
					listeners: {
						beforesetvalue: ( e) => {
							this.reminderIntervalNumber.value = e.value;

							e.value = !!e.value;
						},

						setvalue:({target, newValue, oldValue}) => {

							target.parent!.items.forEach(item => {
								if(item == target) {
									return;
								}

								item.disabled = !newValue;
							})
						},
						beforegetvalue: (e) => {
							if(e.value) {
								if(!this.reminderIntervalNumber.value) {
									this.reminderIntervalNumber.value = 2;
								}
								e.value = this.reminderIntervalNumber.value;
							}
						}
					}
				}),
				this.reminderIntervalNumber = numberfield({
					label: t("Days before close"),
					disabled: true,
					required: true,
					decimals: 0,
					value: 2
				}),
				textarea({
					name: "reminderSubject",
					label: t("Subject"),
					autoHeight: true,
					value: modules.get("business", "forms")!.settings!.reminderSubject,
					disabled: true
				}),
				textarea({
					name: "reminderText",
					label: t("Body"),
					autoHeight: true,
					disabled: true,
					value: modules.get("business", "forms")!.settings!.reminderBody
				}),

			)

		);

		this.addCustomFields();

	}

}